export default __webpack_public_path__ + "static/media/1.22d670b4.png";